// extracted by mini-css-extract-plugin
export default {"fixedMarkup":"FixedMarkup_fixedMarkup__DQMxk","switch":"FixedMarkup_switch__RvpBC"};